export enum AccountEvent {
  PlanInformationNotFound = "Plan Information Not Found For Price ID",
  StripeBillingCustomerIdNotFound = "Stripe Billing Customer ID Not Found",
  CreateCheckoutSessionFailed = "Create Checkout Session Failed",
  LearnMoreClicked = "Learn More Clicked",
  StartCheckoutSession = "Start Checkout Session",
  ViewBillingPortalClicked = "View Billing Portal Clicked",
  CancelOrDowngradePlanClicked = "Cancel or Downgrade Plan Clicked",
  PlanCancellationAttempted = "Plan Cancellation Attempted",
  RevenueHeroClick = "Revenue Hero Click",
  RevenueHeroFailed = "Revenue Hero Failed",
  InvalidSubscriptionInfo = "Invalid Subscription Info Provided",
}
